<template>
  <q-banner
    v-if="currentSite.accountOptions.show_login_help_banner && !isDismissed"
    inline-actions
    rounded
    class="q-mb-md"
    :class="currentSite.accountOptions.login_help_banner_color === 'default' ? 'bg-responsive-grey-2 border-responsive-grey-1' : undefined"
    :style="bgColorStyle"
    role="banner"
    :aria-label="$t('auth.loginHelpInformation')"
  >
    <div class="row items-center">
      <div class="col">
        <div
          class="text-weight-medium"
          :class="textColorClass"
          :style="textColorStyle"
          role="heading"
          aria-level="3"
        >
          {{ currentSite.accountOptions.login_help_banner_header_override ? currentSite.accountOptions.login_help_banner_header_override : $t('auth.loginHelpBannerHeader') }}
        </div>
        <div
          class="text-caption"
          :class="textColorClass"
          :style="textColorStyle"
          role="contentinfo"
          :aria-describedby="loginHelpBannerMessage"
        >
          <i18n-t
            :keypath="loginHelpBannerMessage"
            scope="global"
          >
            <template #pleaseResetPassword>
              <internal-or-external-link
                v-if="!currentSite.accountOptions.login_help_banner_message_override"
                :href="currentSite.url('/password/forgot')"
                class="text-underline cursor-pointer q-ml-xs"
                :aria-label="$t('auth.loginHelpBannerMessageLinkText')"
              >
                {{ $t('auth.loginHelpBannerMessageLinkText') }}.
              </internal-or-external-link>
            </template>
          </i18n-t>
        </div>
      </div>
    </div>

    <template #action>
      <q-btn
        flat
        dense
        round
        icon="close"
        size="sm"
        class="col-auto"
        :class="textColorClass"
        :style="textColorStyle"
        :aria-label="$t('common.dismiss')"
        tabindex="0"
        @click="dismissBanner"
      >
        <q-tooltip>
          {{ $t('common.dismiss') }}
        </q-tooltip>
      </q-btn>
    </template>
  </q-banner>
</template>

<script>
import InternalOrExternalLink from 'src/modules/consumer/components/InternalOrExternalLink.vue'

export default {
  name: 'LoginHelpBanner',
  configuration: ['currentSite'],
  components: {
    InternalOrExternalLink
  },
  data () {
    return {
      isDismissed: false
    }
  },
  computed: {
    bgColorStyle () {
      if (this.currentSite.accountOptions.login_help_banner_color === 'default') return null
      const colorHex = this.currentSite.accountOptions.login_help_banner_color === 'custom'
        ? this.currentSite.accountOptions.login_help_banner_color_hex
        : this.$getSiteColorHex(this.currentSite, this.currentSite.accountOptions.login_help_banner_color)
      return this.$q.dark.isActive
        ? `background-color: color-mix(in srgb, ${colorHex}, transparent 90%); border: 1px solid color-mix(in srgb, ${colorHex}, transparent 50%);`
        : `background-color: ${this.$lightenColor(colorHex, 90)}; border: 1px solid ${this.$lightenColor(colorHex, 50)};`
    },
    textColorClass () {
      if (this.currentSite.accountOptions.login_help_banner_color === 'custom') return null
      if (this.currentSite.accountOptions.login_help_banner_color === 'default') return 'text-responsive'
      return `text-${this.currentSite.accountOptions.login_help_banner_color}`
    },
    textColorStyle () {
      if (this.currentSite.accountOptions.login_help_banner_color !== 'custom') return null
      return `color: ${this.currentSite.accountOptions.login_help_banner_color_hex}`
    },
    loginHelpBannerMessage () {
      return this.currentSite.accountOptions.login_help_banner_message_override
        ? this.currentSite.accountOptions.login_help_banner_message_override
        : this.$t('auth.loginHelpBannerMessage')
    },
    loginHelpBannerDismissedKey () {
      return `${this.$constants.localStorageKeys.loginHelpBannerDismissed}_${this.currentSite.id}`
    }
  },
  mounted () {
    const stored = localStorage.getItem(this.loginHelpBannerDismissedKey)
    if (stored) {
      try {
        const data = JSON.parse(stored)
        const now = Date.now()

        // Check if expired and remove if so
        if (data.expiresAt && data.expiresAt < now) {
          localStorage.removeItem(this.loginHelpBannerDismissedKey)
          this.isDismissed = false
        } else {
          this.isDismissed = data.dismissed || false
        }
      } catch (e) {
        // If parsing fails, remove invalid data
        localStorage.removeItem(this.loginHelpBannerDismissedKey)
        this.isDismissed = false
      }
    } else {
      this.isDismissed = false
    }
  },
  methods: {
    dismissBanner () {
      this.isDismissed = true
      const expirationDate = new Date()
      expirationDate.setDate(expirationDate.getDate() + 30)
      localStorage.setItem(this.loginHelpBannerDismissedKey, JSON.stringify({
        dismissed: true,
        expiresAt: expirationDate.getTime()
      }))
    }
  }
}
</script>
